import PropTypes from 'prop-types'

import { getAssetLink } from '../../helpers/get-asset-link'

const TrainingDetailsLearnMore = ({ opened, close, file }) => (
  <div className={`modal modal--organisation ${opened ? 'is-active' : ''}`}>
    <div className="modal-background" />
    <div className="modal-content">
      <div className="box">
        <header className="modal__header">
          Learn more
          <button className="modal-close is-large" aria-label="close" onClick={close} />
        </header>
        <div className="modal__inner">
          <section className="ctp-package vcentered autoheight">
            <object
              data={
                file.includes('data:application/pdf;')
                  ? file
                  : getAssetLink({
                      path: 'chitown-images/training',
                      file: file,
                      fallback: { file: 'training_image.png' },
                    })
              }
              type="application/pdf"
              width="600"
              height="700"
            />
          </section>
        </div>
      </div>
    </div>
  </div>
)

TrainingDetailsLearnMore.propTypes = {
  opened: PropTypes.bool,
  close: PropTypes.func,
  file: PropTypes.string,
}

export default TrainingDetailsLearnMore
